import { Box } from '@chakra-ui/react'

import type { IFAQ } from '../../data/faq'
import { FAQAdminItem } from './FAQAdminItem'

export const FAQAdminList = ({ items }: { items: Array<IFAQ> }) => {
  return (
    <Box sx={{ display: 'grid', gap: 4 }}>
      {items &&
        items.length > 0 &&
        items.map((item) => {
          return <FAQAdminItem key={item.id} item={item} />
        })}

      <FAQAdminItem />
    </Box>
  )
}
